var map = {
	"./arrow-circle-broken-right.svg": 9863,
	"./arrow-circle-right.svg": 5749,
	"./check-circle.svg": 5401,
	"./logo-on-dark.svg": 6682,
	"./logo-on-white.svg": 9738,
	"./register.svg": 5383,
	"./scroll.svg": 2023,
	"./slide-01.svg": 6909,
	"./slide-02.svg": 3934,
	"./slide-03.svg": 8575,
	"./slide-04.svg": 1104,
	"./slide-05.svg": 5489,
	"./slide-06.svg": 8386,
	"./slide-07.svg": 2115,
	"./slide-08.svg": 8836,
	"./slide-09.svg": 9733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4874;